module.exports = __webpack_public_path__ + "media/images/dashboard/dashboard_example-183bc50b635c140901b65361fd12038d.png";